import Patients from "components/patients";

const PatientsView = () => {
  return <Patients />;
};

export default PatientsView;
